module.exports = __webpack_public_path__ + "static/media/car8.55b03b41.jpg";